import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material"
import { RedirectedIds } from "../../../../typing"
import { icons } from "../../../../../../utils/icons"
import { CustomTable } from "../../../../../../components"
import { useTranslation } from "react-i18next"
import { createRef, useLayoutEffect, useState } from "react"
import { useStyles } from "./styles"
import { FilterHeader } from "../../components/filterHeader"
import { useInput } from "./contants"
import { dashboardService } from "../../../../../../utils/constants/callService"
import { Item, ObjectGeneric } from "../../../../../../utils/types/generals"
import { formatTop15 } from "./methods/formatDataToEndpoint"
import { formatResponse } from "./methods/formaEndpointDataToRow"
import { formatUrlQueryFromFilters } from "./methods/formatUrlQuery"
import { FilterHeaderRef } from "../../components/filterHeader/types"
import { useNavigate } from "react-router-dom"
import { currentWeek } from "../methods/calcDates"
import { intervaleList } from "../../../../../../utils/constants/intervaleList"
const defaultDates = {
  from: currentWeek().start.getTime(),
  to: currentWeek().end.getTime(),
  intervale: intervaleList[0]
}
const Top15 = () => {
  const ref = createRef<FilterHeaderRef>()
  const navigate = useNavigate()
  const { input, items, externalValidation, removeValues } = useInput()
  const { t } = useTranslation()
  const styles = useStyles()
  const [bestStores, setBestStores] = useState<any[]>([])
  const [worstStores, setWorstStores] = useState<any[]>([])
  const [loadingBest, setIsLoadingBest] = useState(false)
  const [loadingWorst, setIsLoadingWorst] = useState(false)
  const [lastDates, setLastDates] = useState({
    best: '',
    worst: ''
  })
  const column = [
    {
      id: 'keyCode',
      label: t('general.tags.id'),
    },
    {
      id: 'unit',
      label: t('general.tags.store'),
    },
    {
      id: 'avance',
      label: 'Promedio de avance',
      rowTdStyles: {
        maxWidth: '60px',
      },
      headerCell: {
        maxWidth: '60px',
      }
    },
    {
      id: 'actions',
      rowTdStyles: {
        maxWidth: '20px',
      },
      headerCell: {
        maxWidth: '20px',
      },
      renderCell: (params: any) => {
        return <IconButton onClick={() => {
          const id = params.row.id
          redirectToUnitDetail({ id })
        }}>{icons('search')}</IconButton>
      }
    }
  ]

  const redirectToUnitDetail = ({ id }: { id?: string }) => {
    if (ref.current?.getValues) {
      const defaultValue = ref.current?.getValues()
      const body = formatUrlQueryFromFilters({ ...defaultValue, unit: id })
      navigate(`/dashboard/reports/progress-questionnaire?${body.url}`)
    }
  }
  const handleWorstStores = async (payload: ObjectGeneric, intervale: string) => {
    setIsLoadingWorst(true)

    const response = await dashboardService[intervale == '1w' ? 'unitWeekRankig' : `unitRankig`]({
      body: {
        ...payload,
        "sort": [
          {
            "avance": {
              "order": "asc"
            }
          }
        ]
      }
    })
    const format = formatResponse({response, values: items, intervale})
    setLastDates(prev => ({...prev, worst: format.updateDate}))
    setWorstStores(format.hits)
    setIsLoadingWorst(false)
  }

  const handleBestStores = async (payload: ObjectGeneric, intervale: string) => {
    setIsLoadingBest(true)
    const response = await dashboardService[intervale == '1w' ? 'unitWeekRankig' : `unitRankig`]({
      body: {
        ...payload,
        "sort": [
          {
            "avance": {
              "order": "desc"
            }
          }
        ]
      }
    })
    const format = formatResponse({response, values: items, intervale})
    setLastDates(prev => ({...prev, best: format.updateDate}))
    setBestStores(format.hits)
    setIsLoadingBest(false)
  }
  const improveResults = (
    <Grid key="improveResults" item xl={6} lg={6} md={12} sm={12} xs={12}>
      <Grid
        sx={styles.grid}
        className='improve'
        container
        alignItems="center"
      >
        <Grid item xl={11} lg={11} md={11} sm={11} xs={11}>
          {' '}
          <Typography sx={styles.unitTitle}>
            Unidades con mejores resultados{' '}
            <span >(Top 30)</span>
          </Typography>
          <Typography sx={styles.lastDate}>Última actualización: {lastDates.best}</Typography>
        </Grid>

        <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
          <Tooltip title={t('ToolTips.refresh')}>
            <IconButton
              onClick={() => {
                callBestStores()
              }}
            >
              {icons('refresh')}
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
      <CustomTable
        loader={loadingBest}
        column={column}
        row={bestStores}
        onClick={() => { }}
        selected={-1}
      />
    </Grid>
  )
  const worseResults = (
    <Grid key="worseResults" item xl={6} lg={6} md={12} sm={12} xs={12}>
      <Grid
        sx={styles.grid}
        container
        className='worst'
        alignItems="center"
      >
        <Grid item xl={11} lg={11} md={11} sm={11} xs={11}>
          {' '}
          <Typography sx={styles.unitTitle}>
            Unidades con peores resultados <span >(Top 30)</span>
          </Typography>
          <Typography sx={styles.lastDate}>Última actualización: {lastDates.worst}</Typography>
        </Grid>
        <Grid item xl={1} lg={1} md={1} sm={1}>
          <Tooltip title={t('ToolTips.refresh')}>
            <IconButton
              onClick={() => {
                callWorstStores()
              }}
            >
              {icons('refresh')}
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
      <CustomTable
        loader={loadingWorst}
        column={column}
        row={worstStores}
        onClick={() => { }}
        selected={-1}
      />
    </Grid>
  )
  const callBestStores = (payload?: {
    dafaultValue: ObjectGeneric;
  }) => {
    const defaultValues: ObjectGeneric = payload?.dafaultValue || (ref.current?.getValues ? ref.current?.getValues() : {})
    const { body: best } = formatTop15(defaultValues, 'desc')
    handleBestStores(best, defaultValues?.intervale?.value)
  }
  const callWorstStores = (payload?: {
    dafaultValue: ObjectGeneric;
  }) => {
    const defaultValues: ObjectGeneric = payload?.dafaultValue || (ref.current?.getValues ? ref.current?.getValues() : {})
    const { body: worst } = formatTop15(defaultValues, 'asc')
    handleWorstStores(worst, defaultValues?.intervale?.value)
  }

  const getFilter = (payload: {
    dafaultValue: ObjectGeneric;
  }) => {
    callBestStores(payload)
    callWorstStores(payload)
  }

  const refresh = (payload: {
    dafaultValue: ObjectGeneric;
  }) => {
    callBestStores(payload)
    callWorstStores(payload)
  }

  useLayoutEffect(() => {
    if ((items.unit as Item[])?.length) {
      callBestStores({ dafaultValue: defaultDates })
      callWorstStores({ dafaultValue: defaultDates })
    }
  }, [items.unit])
  return (
    <Grid key={'top-15'} item xs={12}>
      <div id={RedirectedIds.TOP_15} />

      <Box sx={styles.card}>
        <Box sx={styles.headerInputs}>
          <Typography sx={styles.titleHeaders}>Top 30 de unidades</Typography>

          <FilterHeader countDefault={1} hiddenRefresh cleanFilter={removeValues} ref={ref} defaultValues={defaultDates} filterData={getFilter} refresh={refresh} title="Filtrar top 30 de unidades" externalValidation={externalValidation} input={input} />
        </Box>

        <Grid container spacing={3}>
          {improveResults}

          {worseResults}
        </Grid>
      </Box>
    </Grid>
  )
}

export { Top15 }
